import { ApiResponse } from '@restaurant/types';
import { Category, UpsertCategoriesRequest } from '../types/Category';
import httpClient from '~/http';

const CATEGORY_URL = '/api/v1/category';

export type GetCategoriesResponse = ApiResponse<Category[]>;
export const getCategories = () => {
  return httpClient.get<GetCategoriesResponse>(CATEGORY_URL);
};

export type UpsertCategoriesResponse = ApiResponse<null>;
export const upsertCategories = (body: UpsertCategoriesRequest) => {
  return httpClient.post<UpsertCategoriesResponse>(CATEGORY_URL, body);
};
